.sectionEyebrow {
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--mantine-color-gray-6);
    margin: 0;
}

.operationalSectionHeading {
    font-size: var(--mantine-font-size-sm);
    font-weight: 700;
    letter-spacing: 0.045em;
    text-transform: uppercase;
    color: var(--mantine-color-dark-7);
    line-height: 1.3;
    margin: 0;
}

.fillCount {
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    font-size: var(--mantine-font-size-sm);
}

.fillCountMet {
    color: var(--mt-signal-positive-7);
}

.fillCountOpen {
    color: var(--mt-signal-attention-7);
}

.drawerHeader {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-xs);
    padding-top: var(--mantine-spacing-sm);
}

.identityBlock {
    margin: var(--mantine-spacing-sm) 0 0;
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.identityBlockGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 2rem;
    row-gap: 0.45rem;
    margin-top: 0;
}

@media (max-width: 40em) {
    .identityBlockGrid {
        grid-template-columns: 1fr;
    }
}

.identityRow {
    display: grid;
    grid-template-columns: 6rem 1fr;
    align-items: baseline;
    gap: 0.5rem;
}

.identityLabel {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--mantine-color-gray-6);
    line-height: 1.4;
    margin: 0;
}

.identityValue {
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    color: var(--mantine-color-dark-4);
    line-height: 1.4;
    margin: 0;
    font-variant-numeric: tabular-nums;
}

.identityLink {
    color: var(--mantine-color-anchor);
    text-decoration: none;
}

.identityLink:hover {
    text-decoration: underline;
}

.identityDescriptionRow {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.identityDescriptionRowGrid {
    grid-column: 1 / -1;
}

.identityDescriptionValue {
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    color: var(--mantine-color-dark-4);
    line-height: 1.5;
    margin: 0;
    white-space: pre-wrap;
}

.drawerJobTitle {
    font-size: 1.3125rem;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.015em;
    color: var(--mantine-color-dark-9);
    margin: 0;
    font-family: inherit;
}

.modalTitleBlock {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-xs);
    flex: 1;
    min-width: 0;
    padding-right: var(--mantine-spacing-md);
}

.modalHeader {
    align-items: flex-start;
    min-height: auto;
    padding-bottom: var(--mantine-spacing-xs);
    border-bottom: 1px solid var(--mantine-color-gray-2);
}

.modalBody {
    padding-top: 0;
}

.modalClose {
    align-self: flex-start;
}

.drawerBody {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-md);
    padding-top: var(--mantine-spacing-md);
}

.laneHint {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    margin-bottom: var(--mantine-spacing-sm);
}

.modalTitleBlock .laneHint {
    margin-bottom: 0;
}

.laneHintAccent {
    width: 2px;
    height: 0.7rem;
    border-radius: 1px;
    flex-shrink: 0;
}

.laneHintAccentNeedsAction {
    background-color: var(--mt-signal-attention-5);
}

.laneHintAccentNotifyDrivers {
    background-color: var(--mt-signal-pending-5);
}

.laneHintAccentDispatched {
    background-color: var(--mt-signal-positive-5);
}

.laneHintLabel {
    font-size: 0.6875rem;
    line-height: 1.2;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--mantine-color-gray-8);
}

.laneHintDetail {
    font-size: 0.6875rem;
    line-height: 1.2;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--mantine-color-gray-7);
}

.operationalSection {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-sm) 0;
    border-top: 1px solid var(--mantine-color-gray-2);
}

.operationalSectionFirst {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-sm) 0 0;
}

.requirementBlock {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-xs);
    padding-top: var(--mantine-spacing-xs);
}

.requirementBlock + .requirementBlock {
    margin-top: var(--mantine-spacing-sm);
    padding-top: var(--mantine-spacing-sm);
    border-top: 1px solid var(--mantine-color-gray-2);
}

.requirementBlockGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 2rem;
    row-gap: var(--mantine-spacing-md);
    align-items: start;
}

@media (max-width: 40em) {
    .requirementBlockGrid {
        grid-template-columns: 1fr;
    }
}

.requirementBlockGrid .requirementBlock + .requirementBlock {
    margin-top: 0;
    padding-top: 0;
    border-top: none;
}

.assignedResourceNames {
    font-size: var(--mantine-font-size-sm);
    color: var(--mantine-color-dark-6);
    line-height: 1.5;
}
